/*
TODO - WE NEED TO PARSE THIS INTO OUR SASS:
https://itnext.io/sharing-variables-between-js-and-sass-using-webpack-sass-loader-713f51fa7fa0
*/
let colours = {
	'$cs-body-background': '#F6F7F8', // CS BACKGROUND GREY
	'$cs-body-foreground': '#1b1e24', // CS BACKGROUND CARBON
	'$cs-component-background': '#FFF',

	// Basic
	'$cs-white': '#FFF', // WHITE
	'$cs-black': '#111', // BLACK

	// Theme colors
	'$cs-theme-accent': '#FAA100', // CS ORANGE
	'$cs-theme-primary': '#2B303A', // CS CARBON
	'$cs-theme-secondary': '#455A64', // CS TEAL DARK
	'$cs-theme-secondarylight': '#607D8B', // CS TEAL LIGHT
	'$cs-theme-tertiary': '#FFF',

	// Functional color variables
	'$cs-success': '#4CAF50', // CS GREEN
	'$cs-warning': '#FF5722', // CS AMBER
	'$cs-danger': '#E81E64', // CS ERROR

	'$cs-info': '#aab0be',
	'$cs-extra-light': '#F6F7F8', // CS BACKGROUND GREY
	'$cs-superlight': '#E2E2E2', // CS LIGHT GREY
	'$cs-light': '#B4B5B7', // CS MID GREY
	'$cs-dark': '#4A4A4A', // CS DARK GREY

	// Text colors
	'$cs-text-primary': '#1b1e24', // CS PRIMARY TEXT
	'$cs-text-secondary': '#757575', // CS SECONDARY TEXT
	'$cs-text-tertiary': '#BABABA', // CS TERTIARY TEXT
	'$cs-text-error': '#E81E64', // CS ERROR TEXT

	// Border colors
	'$cs-border-extra-extra-light': '#ececec', // CS KEYLINE LIGHT GREY
	'$cs-border-extra-light': '#E2E2E2', // CS KEYLINE GREY
	'$cs-border-superlight': '#B4B5B7', // CS KEYLINE MID GREY
	'$cs-border-light': '#4A4A4A', // CS KEYLINE DARK GREY
	'$cs-border-dark': '#1B1E24', // CS KEYLINE PRIMARY GREY

	// Logo colors
	'$cs-logo-primary': '#c7c7d5',
	'$cs-logo-secondary': '#7aa099',
	'$cs-dropshadow-color': '#282828',

	// Additional colors for colour coded cells
	'$cs-coloured-cell-silver': '#c0c0c0',
	'$cs-coloured-cell-gray': '#808080',
	'$cs-coloured-cell-black': '#000000',
	'$cs-coloured-cell-red': '#FF0000',
	'$cs-coloured-cell-maroon': '#800000',
	'$cs-coloured-cell-yellow': '#FFFF00',
	'$cs-coloured-cell-olive': '#808000',
	'$cs-coloured-cell-lime': '#00FF00',
	'$cs-coloured-cell-green': '#008000',
	'$cs-coloured-cell-aqua': '#00FFFF',
	'$cs-coloured-cell-teal': '#008080',
	'$cs-coloured-cell-blue': '#0000FF',
	'$cs-coloured-cell-navy': '#000080',
	'$cs-coloured-cell-fuchsia': '#FF00FF',
	'$cs-coloured-cell-purple': '#800080',

	// WYSIWYG styles
	'$cs-wysiwyg-link': '#2d59c8'
};
// Theme colors

let defaultColours = {
	'white': colours['$cs-white'],
	'black': colours['$cs-black'],
	'accent': colours['$cs-theme-accent'],
	'primary': colours['$cs-theme-primary'],
	'secondary': colours['$cs-theme-secondary'],
	'secondarylight': colours['$cs-theme-secondarylight'],
	'tertiary': colours['$cs-theme-tertiary'],
	'success': colours['$cs-success'],
	'info': colours['$cs-info'],
	'warning': colours['$cs-warning'],
	'danger': colours['$cs-danger'],
	'xxlight': colours['$cs-border-extra-extra-light'],
	'extralight': colours['$cs-extra-light'],
	'superlight': colours['$cs-superlight'],
	'light': colours['$cs-light'],
	'dark': colours['$cs-dark'],
	'default': '#404040',
	'bodytext': colours['$cs-body-foreground'],
	'field': colours['$cs-body-background'],
	'component': colours['$cs-component-background'],
	'coloured-cell-silver': colours['$cs-coloured-cell-silver'],
	'coloured-cell-gray': colours['$cs-coloured-cell-gray'],
	'coloured-cell-black': colours['$cs-coloured-cell-black'],
	'coloured-cell-red': colours['$cs-coloured-cell-red'],
	'coloured-cell-maroon': colours['$cs-coloured-cell-maroon'],
	'coloured-cell-yellow': colours['$cs-coloured-cell-yellow'],
	'coloured-cell-olive': colours['$cs-coloured-cell-olive'],
	'coloured-cell-lime': colours['$cs-coloured-cell-lime'],
	'coloured-cell-green': colours['$cs-coloured-cell-green'],
	'coloured-cell-aqua': colours['$cs-coloured-cell-aqua'],
	'coloured-cell-teal': colours['$cs-coloured-cell-teal'],
	'coloured-cell-blue': colours['$cs-coloured-cell-blue'],
	'coloured-cell-navy': colours['$cs-coloured-cell-navy'],
	'coloured-cell-fuchsia': colours['$cs-coloured-cell-fuchsia'],
	'coloured-cell-purple': colours['$cs-coloured-cell-purple']
};

let defaultPalette = {
	'accent': colours['$cs-theme-accent'],
	'primary': colours['$cs-theme-primary'],
	'secondary': colours['$cs-theme-secondary'],
	'tertiary': colours['$cs-theme-tertiary'],
	'success': colours['$cs-success'],
	'info': colours['$cs-info'],
	'warning': colours['$cs-warning'],
	'danger': colours['$cs-danger'],
	'light': colours['$cs-light'],
	'dark': colours['$cs-dark'],
	'green': colours['$cs-success'],
	'amber': colours['$cs-warning'],
	'red': colours['$cs-danger'],
};

const vanillaTheme = [
	{
		"value": defaultColours["success"],
		"classSuffix": "success",
		"label": "Success",
		"position": 1
	},
	{
		"value": defaultColours["warning"],
		"classSuffix": "warning",
		"label": "Warning",
		"position": 2
	},
	{
		"value": defaultColours["danger"],
		"classSuffix": "danger",
		"label": "Danger",
		"position": 3
	},
	{
		"value": defaultColours["coloured-cell-silver"],
		"classSuffix": "coloured-cell-silver",
		"label": "Silver",
		"position": 4
	},
	{
		"value": defaultColours["coloured-cell-gray"],
		"classSuffix": "coloured-cell-gray",
		"label": "Gray",
		"position": 5
	},
	{
		"value": defaultColours["coloured-cell-black"],
		"classSuffix": "coloured-cell-black",
		"label": "Black",
		"position": 6
	},
	{
		"value": defaultColours["coloured-cell-red"],
		"classSuffix": "coloured-cell-red",
		"label": "Red",
		"position": 7
	},
	{
		"value": defaultColours["coloured-cell-maroon"],
		"classSuffix": "coloured-cell-maroon",
		"label": "Maroon",
		"position": 8
	},
	{
		"value": defaultColours["coloured-cell-yellow"],
		"classSuffix": "coloured-cell-yellow",
		"label": "Yellow",
		"position": 9
	},
	{
		"value": defaultColours["coloured-cell-olive"],
		"classSuffix": "coloured-cell-olive",
		"label": "Olive",
		"position": 10
	},
	{
		"value": defaultColours["coloured-cell-lime"],
		"classSuffix": "coloured-cell-lime",
		"label": "Lime",
		"position": 11
	},
	{
		"value": defaultColours["coloured-cell-green"],
		"classSuffix": "coloured-cell-green",
		"label": "Green",
		"position": 12
	},
	{
		"value": defaultColours["coloured-cell-aqua"],
		"classSuffix": "coloured-cell-aqua",
		"label": "Aqua",
		"position": 13
	},
	{
		"value": defaultColours["coloured-cell-teal"],
		"classSuffix": "coloured-cell-teal",
		"label": "Teal",
		"position": 14
	},
	{
		"value": defaultColours["coloured-cell-blue"],
		"classSuffix": "coloured-cell-blue",
		"label": "Blue",
		"position": 15
	},
	{
		"value": defaultColours["coloured-cell-navy"],
		"classSuffix": "coloured-cell-navy",
		"label": "Navy",
		"position": 16
	},
	{
		"value": defaultColours["coloured-cell-fuchsia"],
		"classSuffix": "coloured-cell-fuchsia",
		"label": "Fuchsia",
		"position": 17
	},
	{
		"value": defaultColours["coloured-cell-purple"],
		"classSuffix": "coloured-cell-purple",
		"label": "Purple",
		"position": 18
	}
]

export { colours, defaultColours, defaultPalette, vanillaTheme };
